import { Link } from 'react-router-dom';
import Button from 'components/CustomButtons/Button.jsx';
import GridItem from 'components/Grid/GridItem.jsx';
import GridContainer from 'components/Grid/GridContainer.jsx';
import makeStyles from '@material-ui/styles/makeStyles';
import classNames from 'classnames';
import buttonsStyle from 'assets/jss/material-dashboard-pro-react/views/buttonsStyle';
import extendedFormsStyle from 'assets/jss/material-dashboard-pro-react/views/extendedFormsStyle';

const useStyles = makeStyles({
  ...buttonsStyle,
  ...extendedFormsStyle,
  margin: { margin: '5px' },
});

const FormControlButtons = ({
  cancelPath,
  submitText,
  discardText,
  submitColor,
  handleSubmit,
  submitDisabled,
  secondarySubmitText,
  secondarySubmitDisabled,
  handleSecondarySubmit,
  customButtonsLeft = [],
  customButtonsRight = [],
  dataCy,
  tertiarySubmitText,
  handleTertiarySubmit,
  tertiarySubmitDisabled = false,
}) => {
  const classes = useStyles();

  return (
    <GridContainer justify="flex-end">
      <GridItem data-cy={dataCy || '__buttons_add_and_cancel'}>
        {customButtonsLeft.map(({ label, ...props }) => (
          // eslint-disable-next-line react/jsx-key -- FIXME
          <Button {...props}>{label}</Button>
        ))}
        {cancelPath && (
          <Link to={cancelPath}>
            <Button className={classNames(classes.marginRight, classes.margin)}>
              {discardText}
            </Button>
          </Link>
        )}
        {tertiarySubmitText && (
          <Button
            color={submitColor || 'success'}
            className={classNames(classes.marginLeft, classes.margin)}
            onClick={handleTertiarySubmit}
            disabled={tertiarySubmitDisabled}
          >
            {tertiarySubmitText}
          </Button>
        )}

        {secondarySubmitText && (
          <Button
            color={submitColor || 'success'}
            className={classNames(classes.marginLeft, classes.margin)}
            onClick={handleSecondarySubmit}
            disabled={secondarySubmitDisabled || false}
          >
            {secondarySubmitText}
          </Button>
        )}

        {submitText && (
          <Button
            color={submitColor || 'success'}
            className={classes.marginLeft}
            onClick={handleSubmit}
            disabled={submitDisabled || false}
          >
            {submitText}
          </Button>
        )}
        {customButtonsRight.map(({ label, ...props }) => (
          // eslint-disable-next-line react/jsx-key -- FIXME
          <Button {...props}>{label}</Button>
        ))}
      </GridItem>
    </GridContainer>
  );
};

export default FormControlButtons;
